import { gql, useQuery } from '@apollo/client';

const MFE_QUICKVIEW_FLAG = gql`
  query MfeQuickviewFlag {
    config {
      quickviewMfeCatalogProductCard: genericType(name: "quickviewMfeCatalogProductCard")
    }
  }
`;

const useGetMfeQuickViewFlag = () => {
  const { data } = useQuery(MFE_QUICKVIEW_FLAG);

  return data?.config?.quickviewMfeCatalogProductCard?.value || false;
};

export default useGetMfeQuickViewFlag;
